import { render, staticRenderFns } from "./MyTargetIcon.vue?vue&type=template&id=6b8892f4&"
import script from "./MyTargetIcon.vue?vue&type=script&lang=js&"
export * from "./MyTargetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports